/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SerializedLegacySegmentNegatableFilter } from 'cio/types/conditions/legacy-filter';
import { computed } from '@ember/object';
import CampaignModel from 'cio/models/campaign';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import { ConditionViewerBackgroundVariant } from 'cio/utils/condition-viewer';

interface CioConditionLabelItemSegmentsArgs {
  condition: SerializedLegacySegmentNegatableFilter;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  campaign?: CampaignModel;
  tagName: string;
  backgroundVariant?: ConditionViewerBackgroundVariant;
  containerClasses?: string;
}

export default class CioConditionLabelItemSegments extends Component<CioConditionLabelItemSegmentsArgs> {
  @computed('args.condition.segments')
  get segmentIds() {
    return this.args.condition.segments ?? [];
  }

  get labelVariant() {
    if (this.args.labelVariant != null) {
      return this.args.labelVariant;
    }

    return this.args.backgroundVariant === ConditionViewerBackgroundVariant.Dark
      ? DataSourceLabelVariant.Light
      : DataSourceLabelVariant.Dark;
  }

  get containerClasses() {
    return this.args.containerClasses ?? '';
  }
}
